export default __webpack_public_path__ + "static/media/products.c91c067f.svg";